<!-- 提取的表格组件 -->
<template>
  <el-table
    ref="wellsoonTable"
    class="gray"
    :data="data"
    border
    highlight-current-row

    :style="{fontSize:lookWidth >= 922 ? '' : '12px' }"
  >
    <el-table-column
      v-for="(item, index) in options"
      :key="index"
      :prop="item.prop"
      :label="item.label"
      :width="item.width"
    >
      <template #header>
        <span class="ellipsis-header" v-if="item.label === '标准规定'">
          <el-tooltip class="item" effect="dark" :content="title" placement="top-start">
            <span>{{ title }}</span>
          </el-tooltip>
        </span>
        <span class="ellipsis-header" v-else>{{ item.label }}</span>
      </template>

      <template #default="scope">
         <div v-if="item.prop === 'name'" :style="{width:lookWidth >= 922 ? '200px' : '' }">
          <span style="display: flex; align-items: center;">
            <span>{{ scope.row.name || '-' }}</span>
            <div v-if="scope.row.remark">
              <el-tooltip class="item" effect="dark" :content="scope.row.remark" placement="right-end">
                <i class="el-icon-question"></i>
              </el-tooltip>
            </div>
          </span>
        </div>
        <!--  :style="{width:lookWidth >= 922 ? '200px' : '' } -->
        <div v-else-if="item.prop === 'value'" :style="{width:lookWidth >= 922 ? '200px' : '' }">
          <span v-if="lookWidth >= 922" style="display: flex; align-items: center;">
            <span>{{ scope.row.value || '-' }}</span>
            <span v-if="scope.row.star > 0">
              (<el-rate
                v-model="scope.row.star"
                style="display: inline-block;"
                disabled
                text-color="#ff9900"
                :max="3"
                :score-template="{value}"
              />)
            </span>
          </span>
           <span v-else style="text-align: center;display: block;">
              {{scope.row.value || '-'}}
              <div v-if="scope.row.star > 0" style="text-align: center;" >
                <el-rate
                  v-model="scope.row.star"
                  disabled
                  text-color="#ff9900" :max='3' score-template="{value}">
                </el-rate>
              </div>

            

            </span>
        </div>
       <span v-else v-html="statusFormat(scope.row, item.prop)" />
      </template>
    </el-table-column>
  </el-table>
</template>


<script>
export default {
  name: 'CustomTable',
  props: {
    data: {
      type: Array,
      required: true,
    },
    options: {
      type: Array,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    lookWidth: {
      type: Number,
      required: true,
    }
  },
  methods: {
    statusFormat(row, column) {
      if (column === 'require') {
        return row.require || '-'
      }else if (column === 'name') {
        return `${row.name}`
      }else {
        // 返回其他不需要处理的正常参数
        return row[column] || '-'
      }
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/components/customTable.vue